import React, { useEffect, useState } from "react";
import LogoutSharpIcon from "@mui/icons-material/LogoutSharp";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import moment from "moment";

const deviceTypeMap = {
  1: "Android App",
  2: "iOS App",
  3: "Web",
};

const ManageSession = () => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [errorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    const sessionId = localStorage.getItem("sessionId");
    const token = localStorage.getItem("token");

    if (!sessionId || !token) {
      setErrorToastMessage("Authentication error. Please log in again.");
      setShowErrorToast(true);
      setLoading(false);
      return;
    }
    setLoading(true);

    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };

    try {
      const response = await axios.post(`/Account/ManageSessionInfo`, data);
      setSessions(response.data.responseData);
      setToastMessage("Sessions loaded successfully.");
      setShowToast(true);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          setWarningToastMessage(
            error.response.data.message || "No Sessions found."
          );
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(
            error.response.data.message || "Something went wrong."
          );
          setShowErrorToast(true);
        }
      } else {
        setErrorToastMessage("Network error. Please try again.");
        setShowErrorToast(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async (loginHstryId) => {
    const sessionId = localStorage.getItem("sessionId");

    try {
      const res = await axios.post(
        `/Account/ActiveSessionAction?Action=Logout&LoginHstryId=${loginHstryId}`,
        { deviceType: "Web", sessionId }
      );
      setToastMessage(res?.message);
      setShowToast(true);
      fetchSessions();
    } catch (error) {
      setErrorToastMessage("Failed to logout session.");
      setShowErrorToast(true);
    }
  };

  const handleLogoutAll = async () => {
    const sessionId = localStorage.getItem("sessionId");

    try {
      const res = await axios.post(
        `/Account/ActiveSessionAction?Action=LogoutAll`,
        {
          deviceType: "Web",
          sessionId,
        }
      );
      setToastMessage(res?.message);
      setShowToast(true);
      setSessions([]);
    } catch (error) {
      setErrorToastMessage("Failed to log out all sessions.");
      setShowErrorToast(true);
    }
  };

  return (
    <>
      <div className="setting-header">
        <h4>Manage Sessions</h4>
      </div>
      <div className="p-3 privacy">
        {loading ? (
          <p>Loading...</p>
        ) : sessions.length > 0 ? (
          sessions.map((session) => (
            <div key={session.loginHstryId}>
              <p className="sessionName">
                {deviceTypeMap[session.deviceType] || "Unknown Device"}
              </p>
              <div className="d-flex justify-content-between sessionAction">
                <p className="sessionTime">
                  {session.deviceType === 3
                    ? `IP Address: ${session.ipaddress}`
                    : session.deviceInfo}{" "}
                  . Since{" "}
                  {moment(session.startTime).format("Do MMM YYYY, hh:mm A")}
                </p>
                <LogoutSharpIcon
                  className="material-symbols-sharp pointer"
                  onClick={() => handleLogout(session.loginHstryId)}
                />
              </div>
            </div>
          ))
        ) : (
          <p>No active sessions</p>
        )}
        <div className="text-end mt-3">
          <button
            type="submit"
            className="btnDanger mt-3 text-center"
            onClick={handleLogoutAll}
          >
            Sign out all
          </button>
        </div>
      </div>
    </>
  );
};

export default ManageSession;
